// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import pswotEntity from './entities/pswot.json';
import pswotMenu from '../pages/pswot/menu.json';
import pswotFullForm from '../pages/pswot/forms/full.json';
import pswotContextForm from '../pages/pswot/forms/context.json';
import pswotMiniForm from '../pages/pswot/forms/mini.json';
import pswotLookupForm from '../pages/pswot/forms/lookup.json';
import pswotTableView from '../pages/pswot/views/table.json';
import pswotStagesView from '../pages/pswot/views/stages.json';
import pswotCardsView from '../pages/pswot/views/cards.json';
import pswotInlineView from '../pages/pswot/views/inline.json';
import pswotBacklogView from '../pages/pswot/views/backlog.json';
import pswotSplitView from '../pages/pswot/views/split.json';
import pswotCalendarView from '../pages/pswot/views/calendar.json';
import pswotDashboardView from '../pages/pswot/views/dashboard.json';

/** Тип запису «Елемент SWOT» зі сторінками пакета: меню, форми та подання з pages/pswot/. */
export const pswotDefinition: IRecordTypeDefinition = {
  ...pswotEntity,
  views: assembleViewSet({
      table: pswotTableView,
      stages: pswotStagesView,
      cards: pswotCardsView,
      inline: pswotInlineView,
      backlog: pswotBacklogView,
      split: pswotSplitView,
      calendar: pswotCalendarView,
      dashboard: pswotDashboardView,
  }),
  form: pswotFullForm,
  forms: { full: pswotFullForm, context: pswotContextForm, mini: pswotMiniForm, lookup: pswotLookupForm },
  menu: pswotMenu,
} as IRecordTypeDefinition;
